import styled from 'styled-components';

export const StyledEmojiPickerList = styled.div`
  height: 200px;
  position: relative;
  overflow: hidden;
  box-shadow: ${(p) => p.theme.shadows.all};
  border-radius: ${(p) => p.theme.space[3]};
  background-color: ${(p) => p.theme.alias.bg};
`;

export const StyledEmojiPickerGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(6, 1fr);
  overflow: auto scroll;
  height: calc(100% - 40px);
`;

export const StyledEmojiPickerIcon = styled.button`
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;

  &:hover {
    background-color: ${(p) => p.theme.alias.light};
  }

  &:focus-visible {
    background-color: ${(p) => p.theme.alias.focusBg};
  }
`;
